// @ts-nocheck

import Vue from 'vue';
import Store from './vuex/store';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import ErrorMessages from '@/components/form/ErrorMessages.vue';
import Environment from '@/scripts/environment';
import {
  required,
  email,
  min_value,
  max_value,
  min,
  max
} from 'vee-validate/dist/rules';
import { min } from 'moment';
import { formatMoney } from '@/scripts/helper';

extend('required', {
  validate (value) {
    return {
      required: true,
      valid: ['', null, undefined].indexOf(value) === -1
    };
  },
  computesRequired: true,
  message: "Required"
});

extend('requiredByState', {
  params: ['target'],
  validate: (value, { target }) => {
    const riskAddress = Store.getters.getSubmissionDataValue('Risk');

    if (riskAddress.State === target) {
      return {
        required: true,
        valid: ['', null, undefined].indexOf(value) === -1
      };
    } else {
      return true;
    }
  },
  computesRequired: true,
  message: `Required by your state`
});

extend('regionRequired', {
  validate: (value) => {
    const mailingAddress = Store.getters.getSubmissionDataValue('MailingAddress');
    if (!mailingAddress || !mailingAddress.CountryCode) {
      return true;
    }
    if (mailingAddress.CountryCode === 'MX' || mailingAddress.CountryCode === 'CA') {
      return {
        required: true,
        valid: ['', null, undefined].indexOf(value) === -1
      };
    } else {
      return true;
    }
  },
  computesRequired: true,
  message: `Required for Mexico and Canada`
});

// Add a rule.
extend('secret', {
  validate: value => value === 'example',
  message: 'This is not the magic word.'
});

// extend('email', {
//   validate(value) {
//     if (!value) return true;
//     const re = /\S+@\S+\.\S+/;
//     return re.test(value);
//   },
//   message: 'Please enter a valid email address.'
// });

extend('email', {
  ...email,
  message: 'The email address is not valid.'
});

extend('emailDomain', {
  params: ['domain'],
  validate: (value, { domain }) => {
    if (!value) return true;
    return value.indexOf('@' + domain) > -1;
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Please enter an email address that ends in ' + placeholders.domain + '.';
  }
});

extend('emailNotMyself', {
  validate: (value) => {
    if (!value) return true;
    const email = Store.getters.getUserEmail;
    return email.toLowerCase() != value.toLowerCase();
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Please do not enter your own email address.';
  }
});

extend('noDuplicateTextEntries', {
  validate: (value) => {
    if (!value || !value.length) return true;

    let hasDuplicate = false;
    const uniqueItems = [];
    value.forEach(v => {
      if (uniqueItems.indexOf(v) > -1) hasDuplicate = true;
      else uniqueItems.push(v);
    });

    return !hasDuplicate;
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Please do not enter any duplicates.';
  }
});

extend('phone', {
  validate (value) {
    if (!value) return true;
    return value.split('-').join('').length == 10;
  },
  message: 'Please enter a valid phone number.'
});

extend('dateAfterToday', {
  validate: value => {
    const date = (new Date(value)).setHours(0, 0, 0, 0);
    const today = (new Date()).setHours(0, 0, 0, 0);
    return date >= today;
  },
  message: 'Date must be after today.'
});

extend('dateOnOrBeforeToday', {
  validate: value => {
    const date = (new Date(value)).setHours(0, 0, 0, 0);
    const today = (new Date()).setHours(0, 0, 0, 0);
    return date <= today;
  },
  message: 'Date must be on or before today.'
});

extend('dateMustBeToday', {
  validate: value => {
    const date = (new Date(value)).setHours(0, 0, 0, 0);
    const today = (new Date()).setHours(0, 0, 0, 0);
    return date == today;
  },
  message: 'Date must be today.'
});

extend('dateBeforeToday', {
  validate: value => {
    const date = (new Date(value)).setHours(0, 0, 0, 0);
    const today = (new Date()).setHours(23, 59, 59, 0);
    return date <= today;
  },
  message: 'Date must be today or earlier.'
});

extend('validDate', {
  validate: value => {
    const isValidDate = Date.parse(value);
    if (isNaN(isValidDate)) return false;

    const date = (new Date(value)).setHours(0, 0, 0, 0);
    const valid = (new Date('1/1/1890')).setHours(0, 0, 0, 0);
    return date >= valid;
  },
  message: 'Please enter a valid date.'
});

extend('effectiveDateAfterCreateDate', {
  validate: value => {
    let module = 'quoteForm';
    if (window.location.href.indexOf('additional') > -1) {
      module = 'additionalForm';
    }

    if (Store.getters.userHasRestrictedFeature('Submission_BackdateEffectiveDate')) return true;
    const effectiveDate = new Date(value);
    effectiveDate.setHours(0, 0, 0, 0);
    const createDate = new Date(Store.getters.getSubmissionDataValue('CreateDate'));
    createDate.setHours(0, 0, 0, 0);

    return (effectiveDate >= createDate);
  },
  message: `Effective Date cannot be before the date the Submission was started.`
});
extend('notPastContractDate', {
  validate: value => {
    const effectiveDate = (new Date(value)).setHours(0, 0, 0, 0);
    const selectedQuoteId = Store.getters.getSubmissionValue('SelectedQuoteId');
    const quotes = Store.getters.getSubmissionValue('Quotes') || [];
    // During a re-quote (e.g. changing the effective date on the flood workflow) the Quotes
    // array can transiently not contain the selected quote id, but the additional/flood form
    // still holds the live selection. Fall back to it so we preserve the selected quote state
    // instead of crashing on undefined.
    const selectedQuote = quotes.find(q => q.id == selectedQuoteId) || Store.getters['additionalForm/getSelectedQuote'];
    const salesChannel = selectedQuote.SalesChannel;
    const isNonProd = Environment.environment != 'prod';

    switch (salesChannel) { // For Test - Renewals Contracts Kludge User Story 536685
      case "Chubb":
        return effectiveDate < new Date("2027-01-01");
      case "Vave":
        return effectiveDate < new Date("2027-01-01");
      case "Hiscox":
        return effectiveDate < new Date("2027-04-01");
      case "AccessAlphaFlood":
        const contractExpirationDate = selectedQuote.ContractExpiration?.value;
        if (contractExpirationDate) {
          const contractDate = (new Date(contractExpirationDate));
          return effectiveDate < contractDate;
        }

        // TODO: Inflight quotes might get caught here since they may or may not have an expiration date set yet.
        // Its safe to assume that these quotes belong to the lex contract for now but we should remove this
        // fallback prior to releasing the Chubb RBE
        return true;
    }
    return true;
  },
  message: `The selected effective date is outside of the contract term. Please return to the previous page to request an effective date change`
});
extend('validBackdate', {
  validate: value => {
    if (!value) return true;
    // if (Store.getters.getUserRole == 'admin') return true;
    if (Store.getters.userHasRestrictedFeature('Submission_BackdateEffectiveDate')) return true;

    const effectiveDate = new Date(value);
    effectiveDate.setHours(0, 0, 0, 0);

    const valid = new Date();
    valid.setDate((new Date()).getDate() - parseInt(14));
    valid.setHours(0, 0, 0, 0);

    return (effectiveDate >= valid);
  },
  message: `Date must be less than 14 days old.`
});

extend('validBackdateFlood', {
  validate: value => {
    if (!value) return true;

    const effectiveDate = new Date(value);
    effectiveDate.setHours(0, 0, 0, 0);

    const todaysDate = new Date();
    todaysDate.setHours(0, 0, 0, 0);
    if (Store.getters.userHasRestrictedFeature('Submission_BackdateEffectiveDate')) {
      const thirtyDaysBeforeToday = new Date();
      thirtyDaysBeforeToday.setDate(todaysDate.getDate() - 31);
      return effectiveDate > thirtyDaysBeforeToday;
    }

    return (effectiveDate >= todaysDate);
  },
  message: () => {
    return Store.getters.userHasRestrictedFeature('Submission_BackdateEffectiveDate') ? 'Cannot backdate more than 30 days. Please choose an effective date (less than 30 days prior to today\'s date; after the quote inception date, prior to the quote expiration date)' : `Date can't be before today.`;
  }
});

extend('greaterThanBuildingValuation', {
  params: ['target'],
  validate: (value, { target }) => {
    if (!value) return true;
    const valuationAmount = !target ? Store.getters.getSubmissionDataValue('BuildingValuationAmount') : target;

    return (valuationAmount != null && valuationAmount >= value);
  },
  message: `Dwelling Coverage should be less than or equal to Building Estimated Valuation Amount`
});

extend('greaterThanContentsValuation', {
  params: ['target'],
  validate: (value, { target }) => {
    if (!value) return true;
    const valuationAmount = !target ? Store.getters.getSubmissionDataValue('ContentsValuationAmount') : target;

    return (valuationAmount != null && valuationAmount >= value);
  },
  message: `Personal Property Coverage should be less than or equal to Personal Property Valuation Amount`
});

// Excess flood coverage rules. The quote page keeps its values in the submission data, while the endorsement
// page keeps them on the endorsement form, so each rule set is built over a reader for where its values live.
const readFromSubmission = (name) => Store.getters.getSubmissionDataValue(name);
const readFromEndorsementForm = (name) => Store.getters.getControlValue('endorsementForm', name);

// The Personal Property attachment point is fixed for excess, so the limit rules use it directly rather than the
// disabled deductible control, whose stored value is a default that can be empty or 0
const EXCESS_CONTENTS_NFIP_LIMIT = 100000;

const floodExcessRules = (read) => ({
  buildingValuation: {
    validate: (value) => {
      const buildingDeductible = read('ExcessBuildingDeductible');
      return value > buildingDeductible;
    },
    message: `Building Estimated Valuation must be greater than Building Deductible`
  },
  dwellingLimit: {
    validate: (value) => {
      const hasUnderlyingPolicyNonNFIPMax = read('HasUnderlyingPolicyNonNFIPMax');
      const valuationAmount = read('BuildingValuationAmount');
      const NFIPLimit = read('ExcessBuildingDeductible');
      if (!value) return false;
      if (!hasUnderlyingPolicyNonNFIPMax) {
        return value <= (valuationAmount - NFIPLimit);
      }
      return value > 0 && value <= valuationAmount;
    },
    message: (field, placeholders) => {
      const value = placeholders._value_;
      const hasUnderlyingPolicyNonNFIPMax = read('HasUnderlyingPolicyNonNFIPMax');
      const valuationAmount = read('BuildingValuationAmount');
      const NFIPLimit = read('ExcessBuildingDeductible');
      if (!value || value === '0') {
        return `Dwelling Coverage value must be greater than 0 and cannot exceed Building Estimated Valuation.`;
      } else if (hasUnderlyingPolicyNonNFIPMax && (value > valuationAmount)) {
        return `Dwelling Coverage value cannot exceed Building Estimated Valuation.`;
      }
      if (!hasUnderlyingPolicyNonNFIPMax && (value > (valuationAmount - NFIPLimit))) {
        return `Dwelling Coverage value cannot exceed the Building Estimated Valuation minus NFIP Limit (${valuationAmount - NFIPLimit}).`;
      }
    }
  },
  personalPropertyLimit: {
    validate: (value) => {
      const hasUnderlyingPolicyNonNFIPMax = read('HasUnderlyingPolicyNonNFIPMax');
      const NFIPLimit = EXCESS_CONTENTS_NFIP_LIMIT;
      const valuationAmount = Number(read('ContentsValuationAmount'));
      if (!value && !hasUnderlyingPolicyNonNFIPMax) return true;
      if (!hasUnderlyingPolicyNonNFIPMax) {
        return value <= (valuationAmount - NFIPLimit);
      }
      return value <= valuationAmount;
    },
    message: (field, placeholders) => {
      const value = placeholders._value_;
      const hasUnderlyingPolicyNonNFIPMax = read('HasUnderlyingPolicyNonNFIPMax');
      const valuationAmount = Number(read('ContentsValuationAmount'));
      const NFIPLimit = EXCESS_CONTENTS_NFIP_LIMIT;
      if (hasUnderlyingPolicyNonNFIPMax && (value > valuationAmount)) {
          return `Personal Property Coverage value cannot exceed Personal Property Estimated Valuation.`;
        }
      if (!hasUnderlyingPolicyNonNFIPMax && (value > valuationAmount - NFIPLimit)) {
        return `Personal Property Coverage value must not exceed the Personal Property Estimated Valuation minus NFIP Limit (${valuationAmount - NFIPLimit}).`;
      }
      if (!hasUnderlyingPolicyNonNFIPMax && (value > NFIPLimit)) {
        return `Personal Property Coverage value cannot exceed NFIP Limit (${NFIPLimit}).`;
      }
    }
  }
});

const quoteExcessRules = floodExcessRules(readFromSubmission);
extend('floodExcessBuildingValuation', quoteExcessRules.buildingValuation);
extend('floodExcessDwellingLimit', quoteExcessRules.dwellingLimit);
extend('floodExcessPersonalProperlyLimit', quoteExcessRules.personalPropertyLimit);

const endorsementExcessRules = floodExcessRules(readFromEndorsementForm);
extend('floodExcessEndorsementBuildingValuation', endorsementExcessRules.buildingValuation);
extend('floodExcessEndorsementDwellingLimit', endorsementExcessRules.dwellingLimit);
extend('floodExcessEndorsementPersonalProperlyLimit', endorsementExcessRules.personalPropertyLimit);

extend('effectiveDateBeforeExpirationDate', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(value);
    const expirationDate = new Date(target);
    return (effectiveDate < expirationDate);
  },
  message: `Effective Date must be before Expiration Date.`
});

extend('expirationDateAfterEffectiveDate', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(target);
    const expirationDate = new Date(value);
    return (expirationDate > effectiveDate);
  },
  message: `Expiration Date must be after Effective Date.`
});

extend('endorsementDateOnOrAfterEffectiveDate', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(target);
    const expirationDate = new Date(value);
        return (expirationDate >= effectiveDate);
  },
  message: `Date must be on or after Effective Date.`
});

extend('endorsementDateOnOrBeforeExpirationDate', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(value);
    const expirationDate = new Date(target);
    return (effectiveDate <= expirationDate);
  },
  message: `Date must be on or before Expiration Date.`
});

extend('endorsementDateOnOrAfterLatestEffectiveDate', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(value);
    const expirationDate = new Date(target);
    return (effectiveDate >= expirationDate);
  },
  message: `Date must be on or after latest Endorsement Effective Date.`
});

extend('expirationDateNotMoreThan18MonthsFromEffective', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(target); // new Date(value)
    const expirationDate = new Date(value);
    const eighteenMonthsFromEffective = new Date((effectiveDate.setMonth(effectiveDate.getMonth() + 18)));
    return (expirationDate <= eighteenMonthsFromEffective);
  },
  message: `Expiration Date must be no greater than 18 months from Effective Date.`
});
extend('expirationDateNotMoreThan1YearEffective', {
  params: ['target'],
  validate: (value, { target }) => {
    const effectiveDate = new Date(target); // new Date(value)
    const expirationDate = new Date(value);
    const eighteenMonthsFromEffective = new Date((effectiveDate.setYear(effectiveDate.getFullYear() + 1)));
    return (expirationDate <= eighteenMonthsFromEffective);
  },
  message: `Expiration Date must be no greater than 1 year from Effective Date.`
});
extend('dateNotMoreThan60DaysFromToday', {
  validate: value => {
    if (!value) return true;
    const days = Store.getters.getUserRole == 'admin' ? 90 : 60; // To help with quick renewals
    const dateEntered = new Date(value);
    const DaysFromToday = new Date();
    DaysFromToday.setDate(DaysFromToday.getDate() + days);
    return (dateEntered <= DaysFromToday);
  },
  message: `Date must be no greater than 60 days from today.`
});
extend('dateNotMoreThan30DaysFromToday', {
  validate: value => {
    if (!value) return true;
    const days = Store.getters.getUserRole == 'admin' ? 90 : 30; // To help with quick renewals
    const dateEntered = new Date(value);
    const DaysFromToday = new Date();
    DaysFromToday.setDate(DaysFromToday.getDate() + days);
    return (dateEntered <= DaysFromToday);
  },
  message: `Date must be no greater than 30 days from today.`
});
extend('backdateNotMoreThanDaysFromToday', {
  params: ['days'],
  validate: (value, { days }) => {
    if (!value) return true;

    const dateEntered = new Date(value);
    const daysFromToday = new Date();
    daysFromToday.setDate(daysFromToday.getDate() - parseInt(days));
    return (dateEntered >= daysFromToday);
  },
  message: (field, placeholders) => {
    return 'Backdate must be no greater than ' + placeholders.days + ' days from today.';
  }
});

extend('dateNotMoreThan3MonthsFromToday', {
  validate: value => {
    if (!value) return true;

    const dateEntered = new Date(value);
    const todaysDate = new Date();
    const threeMonthsFromToday = new Date((todaysDate.setMonth(todaysDate.getMonth() + 3)));
    return (dateEntered <= threeMonthsFromToday);
  },
  message: `Date must be no greater than 3 months from today.`
});

extend('stepMaxValue', {
  validate: value => {
    if (!value) return true;

    const foundationType = Store.getters.getSubmissionDataValue('FoundationType');

    switch (foundationType) {
      case 'Elevated on Crawlspace':
      case 'Slab On Fill':
      case 'Sub Grade Crawlspace':
        return value <= 8;
      case 'Piers / Posts / Pilings':
        return value <= 26;
      default:
        return true;
    }
  },
  message: (fieldName, placeHolders) => {
    const foundationType = Store.getters.getSubmissionDataValue('FoundationType');
    let maxSteps = '8';
    switch (foundationType) {
      case 'Elevated on Crawlspace':
      case 'Slab On Fill':
      case 'Sub Grade Crawlspace':
        maxSteps = '8';
        break;
      case 'Piers / Posts / Pilings':
        maxSteps = '26';
        break;
      default:
        break;
    }
    return 'Maximum Number of Steps cannot exceed ' + maxSteps;
  }
});

extend('wholeInteger', {
  validate: value => {
    if (!value && value !== 0) return true;

    const numValue = parseFloat(value);
    return Number.isInteger(numValue);
  },
  message: 'Number of steps must be entered as a whole number.'
});

extend('needToAbideBy7DayWaitingPeriod', {
  validate: value => {
    if (!value || Store.getters.userHasRestrictedFeature('Submission_BackdateEffectiveDate')) return true;
    const dateEntered = new Date(value);

    const sevenDaysFromNow = new Date();
    sevenDaysFromNow.setDate(sevenDaysFromNow.getDate() + 7);
    sevenDaysFromNow.setHours(0, 0, 0, 0);

    const ActiveInsurancePolicy = Store.getters.getControl('additionalForm', 'ActiveInsurancePolicy');
    const LoanClosingSituation = Store.getters.getControl('additionalForm', 'LoanClosingSituation');
    const NewlyClassified = Store.getters.getControl('additionalForm', 'NewlyClassified');

    if (!(ActiveInsurancePolicy.value || LoanClosingSituation.value || NewlyClassified.value)) { return (dateEntered >= sevenDaysFromNow); }
    return true;
  },
  message: `Effective Date needs to be after 7 day waiting period.`
});

extend('dateLessThanDaysOld', {
  params: ['days'],
  validate: (value, { days }) => {
    if (!value) return true;

    const date = new Date(value);
    date.setHours(0, 0, 0, 0);

    const valid = new Date();
    valid.setDate((new Date()).getDate() - parseInt(days));
    valid.setHours(0, 0, 0, 0);

    return date >= valid;
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Date must be less than ' + placeholders.days + ' days old.';
  }
});

extend('dateLessThanYearsOld', {
  params: ['years'],
  validate: (value, { years }) => {
    if (!value) return true;

    const date = new Date(value);
    date.setHours(0, 0, 0, 0);

    const valid = new Date();
    valid.setFullYear((new Date()).getFullYear() - parseInt(years));
    valid.setHours(0, 0, 0, 0);

    valid.setHours(0, 0, 0, 0);
    return date >= valid;
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Date must be less than ' + placeholders.years + ' years old.';
  }
});

extend('notZero', {
  validate: value => {
    return value !== 0;
  },
  message: 'Value cannot be 0.'
});

extend('subFormTableOpen', {
  validate: () => {
    return false;
  },
  message: 'Please click Save to finish editing this entry.'
});

extend('min_value', {
  ...min_value,
  params: ['min'],
  castValue: value => parseFloat(value),
  message: (fieldName, placeHolders) => {
    let min = placeHolders.min;
    if (fieldName.toLowerCase().indexOf('year') == -1) {
      min = parseInt(min).toLocaleString();
    }
    if (placeHolders._min_) {
      return 'This value must be ' + placeHolders._min_ + ' or higher.';
    } else {
      return 'This value must be ' + min + ' or higher.';
    }
  }
});

extend('max_value', {
  ...max_value,
  params: ['max', 'useValueForErrorMsg'],
  castValue: value => parseFloat(value),
  validate: (value, args) => {
    const coverageForm = Store.getters.getSubmissionDataValue('CoverageOption') ?? Store.getters.getControlValue('endorsementForm', 'CoverageOption');
    // Skipping max value for condo/ho6 due to wind/hail deductible percentages being occassionaly large
    if (coverageForm === 'ho6') return true;
    return max_value.validate(value, args);
  },
  message: (fieldName, placeHolders) => {
    let max = placeHolders.max;
    const useValueForErrorMsg = placeHolders.useValueForErrorMsg;
    if (fieldName.toLowerCase().indexOf('year') == -1) {
      max = parseInt(max).toLocaleString();
    }
    if (useValueForErrorMsg) {
      return 'This value must be ' + placeHolders._max_ + ' or lower.';
    } else {
      return 'This value must be ' + max + ' or lower.';
    }
  }
});

extend('percentBetweenRangeForValue', {
  params: ['minPercent', 'maxPercent', 'target'],
  validate: (value, { minPercent, maxPercent, target }) => {
    const minAmount = parseFloat(target) * (parseFloat(minPercent) / 100);
    const maxAmount = parseFloat(target) * (parseFloat(maxPercent) / 100);
    return (value || value === 0) && value >= minAmount && value <= maxAmount;
  },
  computesRequired: true,
  message: (field, placeholders) => {
    const minAmount = parseFloat(placeholders._target_) * (parseFloat(placeholders.minPercent) / 100);
    const maxAmount = parseFloat(placeholders._target_) * (parseFloat(placeholders.maxPercent) / 100);
    return `Value must be between ${minAmount} and ${maxAmount}`;
  }
});

extend('betweenRangeForValue', {
  params: ['minValue', 'maxPercent', 'target'],
  validate: (value, { minPercent, maxPercent, target }) => {
    const minAmount = parseFloat(target) * (parseFloat(minPercent) / 100);
    const maxAmount = parseFloat(target) * (parseFloat(maxPercent) / 100);
    return (value || value === 0) && value >= minAmount && value <= maxAmount;
  },
  computesRequired: true,
  message: (field, placeholders) => {
    const minAmount = parseFloat(placeholders._target_) * (parseFloat(placeholders.minPercent) / 100);
    const maxAmount = parseFloat(placeholders._target_) * (parseFloat(placeholders.maxPercent) / 100);
    return `Value must be between ${minAmount} and ${maxAmount}`;
  }
});

extend('invalidValues', {
  params: ['invalidValues'],
  validate: (value, { invalidValues }) => {
    return !invalidValues.includes(value.toString());
  },
  computesRequired: true,
  message: () => {
    return `Value is invalid`;
  }
});

extend('greater_than', {
  params: ["min"],
  validate: (value, { min }) => {
    return (value && parseFloat(value) > parseFloat(min));
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Value must be greater than ' + placeholders.min + '.';
  }
});

extend('less_than', {
  params: ["max"],
  validate: (value, { max }) => {
    return (value != null && parseFloat(value) < parseFloat(max));
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Value must be less than ' + placeholders.max + '.';
  }
});

extend('step_value', {
  params: ['step'],
  castValue: value => parseFloat(value),
  validate: (value, { step }) => {
    return value % step === 0;
  },
  message: (fieldName, placeHolders) => {
    const step = placeHolders.step;
    return 'Please round to nearest ' + parseInt(step).toLocaleString() + '.';
  }
});

extend('availableOption', {
  params: ["options"],
  validate: (value, { options }) => {
    try {
      if (typeof (options) === 'object') options = options.join(',');
      const optionsArray = options.split("@@@");
      return optionsArray.indexOf(value + "") > -1;
    } catch (err) {
      console.error('rule error', typeof (options), options);
      return true;
    }
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Please select an available option.';
  }
});

extend('addressOpen', {
  params: ['mode'],
  validate: () => {
    return false;
  },
  // message: 'Please Accept Address'
  message: (fieldName, placeHolders) => {
    const mode = placeHolders.mode;
    if (mode == 'GOOGLE') return "Address cannot be found using Google Lookup, please use Advanced Entry.";
    else return 'Please Accept Address';
  }
});

extend('mortgageeOpen', {
  validate: () => {
    return false;
  },
  message: 'Please finish editing this mortgagee.'
});

// extend('min', {
//   ...min,
//   params: ['length'],
//   computesRequired: true,
//   message: (fieldName, placeHolders) => {
//     const min = placeHolders.length;
//     return 'Minimum Length: ${length}.'
//   }
// })

// extend('max', {
//   ...max,
//   params: ['length'],
//   computesRequired: true,
//   message: (fieldName, placeHolders) => {
//     const min = placeHolders.length;
//     return 'Maximum Length: ${length}.'
//   }
// })

extend('min_length', {
  params: ["min"],
  validate: (value, { min }) => {
    return (value && value.length >= min);
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Minimum Length: ' + placeholders.min;
  }
});

extend('max_length', {
  params: ["max"],
  validate: (value, { max }) => {
    return (value && value.length <= max);
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Maximum Length: ' + placeholders.max;
  }
});

extend('min_count', {
  params: ["min"],
  validate: (value, { min }) => {
    return (value && value.length >= min);
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Please add at least ' + placeholders.min + ' entry.';
  }
});

extend('max_count', {
  params: ["max"],
  validate: (value, { max }) => {
    return (value && value.length <= max);
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return 'Only ' + placeholders.max + ' entries are allowed.';
  }
});

extend('addressLocked', {
  validate: value => {
    return value.Locked;
  },
  message: (fieldName, placeHolders) => {
    return 'Please finish editing the address.';
  }
});

extend('wholeNumber', {
  validate: value => {
    return /^\d+$/.test(value);
  },
  message: 'This value must be a whole number.'
});

extend('notAfterCurrentYear', {
  validate: value => {
    const currentYear = (new Date()).getFullYear();
    return parseInt(value) <= currentYear;
  },
  message: (fieldName, placeHolders) => {
    const max = (new Date()).getFullYear();
    return 'This value cannot be greater than ' + max + '.';
  }
});

export const allowedYearBuilt: number = () => {
  const currentYear = (new Date()).getFullYear();
  const ed = Store.getters.getSubmissionDataValue('EffectiveDate');
  const effectiveDate = new Date(ed);
  const effectiveDateYear = effectiveDate.getFullYear();

  // Per PJ - if effective date is after 7/1 of current year, allow Year Built to be next year
  if (effectiveDateYear == currentYear) {
    if (effectiveDate.getMonth() >= 6) {
      return currentYear + 1;
    }
  }

  return currentYear;
};

extend('validYearBuilt', {
  validate: value => {
    if (!value) return true;
    return parseInt(value) <= allowedYearBuilt();
  },
  message: (fieldName, placeHolders) => {
    const max = allowedYearBuilt();
    return 'This value cannot be greater than ' + max + '.';
  }
});

extend('afterYearBuilt', {
  validate: value => {
    if (!value) return true;
    const yearBuilt = Store.getters.getSubmissionDataValue('YearBuilt');
    if (!yearBuilt) return true;
    return parseInt(value) >= parseInt(yearBuilt);
  },
  message: 'Value cannot be before Original Year Built.'
});

extend('requiredTrue', {
  validate: value => {
    return value === true;
  },
  computesRequired: true,
  message: 'Please accept these conditions.'
});

extend('minDocuments', {
  params: ["min"],
  validate: (value, { min }) => {
    return (value && value.length >= min);
  },
  computesRequired: true,
  message: (field, placeholders) => {
    return placeholders.min == 1 ? 'Please upload at least one document.' : 'Please upload at least ' + placeholders.min + ' documents.';
  }
});

extend('watercrafts', {
  validate: value => {
    const total = (
      parseInt(Store.getters.getSubmissionDataValue('NumberOfWatercrafts0100') || 0) +
      parseInt(Store.getters.getSubmissionDataValue('NumberOfWatercrafts101150') || 0) +
      parseInt(Store.getters.getSubmissionDataValue('NumberOfWatercrafts151200') || 0) +
      parseInt(Store.getters.getSubmissionDataValue('NumberOfWatercrafts201350') || 0) +
      parseInt(Store.getters.getSubmissionDataValue('NumberOfWatercraftsAbove350') || 0)
    );

    return parseInt(value) === total;
  },
  message: (fieldName, placeHolders) => {
    return `The total number of watercrafts below must equal ${placeHolders._value_}.`;
  }
});

extend('windPerilDeductibleAmount', {
  validate: value => {
    if (value.toLowerCase() === 'aop') return true;

    const percentage = parseFloat(value);
    const allPerilDeductible = Store.getters.getSubmissionDataValue('AllPerilDeductible');

    // If all peril deductible is a percentage, compare it directly with the wind peril percentage
    if (allPerilDeductible && (allPerilDeductible + '').indexOf('%') !== -1) {
      return percentage >= parseFloat(allPerilDeductible);
    }

    const coverageForm = Store.getters.getSubmissionDataValue('CoverageOption');
    // RENTERS ONLY get Coverage C since Coverage A does not exist
    const coverageTotal = coverageForm === 'ho4'
      ? Store.getters.getSubmissionDataValue('CovC')
      : Store.getters.getSubmissionDataValue('CovA');
    // The value is calculated as a percentage of coverage
    return coverageTotal * (percentage / 100) >= parseFloat(allPerilDeductible);
  },
  message: 'Please select a wind deductible that is equal to or greater than the AOP deductible.'
});

extend('over18', {
  validate: value => {
    const todaysDate = new Date();
    const eighteenYearsAgo = new Date(todaysDate.setFullYear(todaysDate.getFullYear() - 18));
    return (new Date(value) <= eighteenYearsAgo);
  },
  message: `Individual must be over 18 years old.`
});

extend('humanCombinedFileSize', {
  validate: i => {
    let totalSize = 0;
    const controls = [
      'ShortTermRentalDoc',
      'VacantQuestionnaire',
      'CorpQuestionnaireDoc',
      'BuildersRiskSupDoc',
      'LogHomeQuestionnaireDoc',
      'UnprotectedRatingQuestionnaire',
      'SecondModifiersSupplementalDoc',
      'SupplementalHeatingQuestionnaire',
      'Attachments'
    ];

    controls.forEach(control => {
      const value = Store.getters.getSubmissionDataValue(control);
      if (value && value.length > 0) {
        value.forEach(v => {
          totalSize += v.FileSize;
        });
      }
    });

    return totalSize / 1000000 < 10;
  },
  message: 'Combined size for all files cannot exceed 10 Mb.'
});

extend('notEUCountry', {
  validate: value => {
    if (!value) return true;
    if (value && !value.CountryCode) return true;
    const customerType = Store.getters.getSubmissionDataValue('CustomerType');
    if (customerType != 'individual') return true;

    if (value.IsEuropeanUnion) {
      return false;
    }
    return true;
  },
  message: `If the Insured Entity Domicile Country is a member of the EU, we are unable to accept this risk via the Portal.<br>Please contact your Amwins underwriter directly to discuss further and exit out of this submission.`
});
extend('min5000IfSelected', {
  validate: value => {
    if (!value) return true;
    if (value === 0 || value >= 5000) return true;
  },
  message: `Minimum value for this coverage is 5000`
});

extend('hasLossesInPast5Years', {
  validate: value => {
    if (!value || value != 'Claim History') return true;
    const hasLossHistory = Store.getters.getSubmissionDataValue('LossesInPast5Years');
    if (hasLossHistory) return true;
    return false;
  },
  message: 'No Claim History reported in the previous form.'
});

extend('hasLapseInCoverage', {
  validate: value => {
    if (!value || value != 'Lapse in Coverage/No Prior Coverage') return true;
    const otherRisksAssociated = Store.getters.getSubmissionDataValue('OtherRisksAssociated');
    if (otherRisksAssociated && !otherRisksAssociated.isCoverageLapse) return false;
    return true;
  },
  message: 'Lapse in Coverage not reported in the previous form.'
});

extend('hasOtherRiskAssociated', {
  params: ['target'],
  validate: (value, { target }) => {
    const AnyOtherExposures = target;
    const OtherRisksAssociated = value;
    if (!AnyOtherExposures || !OtherRisksAssociated) return true;
    let checked = false;
    Object.keys(OtherRisksAssociated).forEach((key: string) => {
      if (OtherRisksAssociated[key]) checked = true;
    });

    return (checked);
  },
  message: `Please select at least one exposure.`
});


extend('validMortgageeOrgName', {
  validate: value => {
    if (!value) return true;
    if (value.ID) return true;
    if (!value.Name) return true;

    const invalidTerms = [
      'c/o',
      'c / o',
      'care of',
      'isaoa',
      'atima',
      'attn',
      'attention'
    ];

    const v = ' ' + value.Name.toLowerCase() + ' ';

    const invalid = invalidTerms.some(i =>
      v.indexOf(' ' + i + ' ') > -1 ||
      v.indexOf(' ' + i + ': ') > -1);

    return !invalid;
  },
  message: 'Please remove extra details from the Mortgagee Organization name.'
});

extend('validAOR', {
  validate: value => {
    if (!value) return true;
    return value.Producer || false;
  },
  message: 'Please select a valid licensed agent from the list.'
});

extend('validUnitStory', {
  params: ['BuildingTypeCondo'],
  validate: (value, { BuildingTypeCondo }) => {
    if (!value) return true;
    const v = parseInt(value);
    if (BuildingTypeCondo == 'Low Rise') return v >= 1 && v <= 4;
    else if (BuildingTypeCondo == 'Mid Rise') return v >= 1 && v <= 9;
    else return true;
  },
  message: (field, placeholders) => {
    if (placeholders._BuildingTypeCondo_ == 'Low Rise') return 'This value must be 1-4 for Low Rise buildings.';
    else return 'This value must be 1-9 for Mid Rise buildings.';
  }
});

extend('TIVBelowVaveMax', {
  validate: (value) => {
    if (!value) return true;
    let TIV = Store.getters.getSubmissionDataValue('TIV') ?? Store.getters.getControlValue('endorsementForm', 'TIV');

    if (!TIV) {
      const covA = Store.getters.getSubmissionDataValue('CovA') ?? Store.getters.getControlValue('endorsementForm', 'CovA') ?? 0;
      const covB = Store.getters.getSubmissionDataValue('CovB') ?? Store.getters.getControlValue('endorsementForm', 'CovB') ?? 0;
      const covC = Store.getters.getSubmissionDataValue('CovC') ?? Store.getters.getControlValue('endorsementForm', 'CovC') ?? 0;
      const covD = Store.getters.getSubmissionDataValue('CovD') ?? Store.getters.getControlValue('endorsementForm', 'CovD') ?? 0;
      TIV = covA + covB + covC + covD;
    }
    return TIV <= 3630000;
  },
  message: () => {
   return 'Maximum total coverage cannot exceed 3.63 million';
  }
});

extend('AdditionalTheftVave', {
  validate: (value) => {
    // leaving this here in case there are forms that load with this validtion in it (currently saved forms)
    return true;
  },
  message: () => {
   return 'Additional Theft Not allowed for this.';
  }
});

extend('munichValidDeductible', {
  params: ['CoverageOption', 'CovI', 'CovII'],
  validate: (value, { CoverageOption, CovI, CovII }) => {
    if (!value) return true;

    if (['dp3', 'ho3'].indexOf(CoverageOption) > -1) {
      return parseInt(value) < parseInt(CovI);
    } else if (['ho6'].indexOf(CoverageOption) > -1) {
      return parseInt(value) < parseInt(CovI) + parseInt(CovII);
    }
  },
  message: (field, placeholders) => {
    return 'Enter a valid deductible.';
  }
});

extend('validDigitalAIType', {
  validate: value => {
    if (!value) return true;

    const invalidDigitalAITypes = ['Builder/GC –Insured & Licensed'];
    if (invalidDigitalAITypes.indexOf(value) > -1) return false;

    return true;
  },
  message: 'Not Eligible for Digital Submission'
});

extend('validateNumberRange', {
  validate: enteredNumber => {
    if (enteredNumber < -2147483647 || enteredNumber > 2147483647) {
        return false;
    }
    return true;
  },
  message: 'Enter a valid amount.'
});

extend('payment', {
  validate: value => {
    return value && !!value.isValid;
  },
  message: 'Required',
  computesRequired: true
});

extend('requireInsuredEmailOptions', {
  validate: value => {
    return value && !!value.isValid;
  },
  computesRequired: true
});

extend('renewalCoverageCanNotBeReduced', {
  params: ['targetCoverageName', 'currentPolicyCoverageValue'],
  validate: (value, { targetCoverageName, currentPolicyCoverageValue }) => {
    if (value === 0 && (targetCoverageName === 'CovB' || targetCoverageName === 'CovC' || targetCoverageName === 'CovD')) {
      return true;
    }
    const convertedCurrentPolicyCoverageValue = parseInt(currentPolicyCoverageValue);
    return (value >= convertedCurrentPolicyCoverageValue);
  },
  message: (fieldName, params) => {
    const convertedCurrentPolicyCoverageValue = parseInt(params.currentPolicyCoverageValue);
    return `Coverage can't be reduced below ${formatMoney(convertedCurrentPolicyCoverageValue)} at the time of renewal.`;
  }
});

// Globally registered components for validation
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ErrorMessages', ErrorMessages);
